import React from 'react';
import ServicePageTemplate, { ALL_SERVICES } from './ServicePageTemplate';

const pageData = {
  seo: {
    title: 'UI/UX Design Agency | User Experience Design | RojrzTech',
    description:
      'RojrzTech is a leading UI/UX design agency creating user-first digital experiences. From wireframes to prototypes, we design interfaces people actually enjoy using.',
  },
  hero: {
    badge: 'UI/UX DESIGN EXPERTS',
    slides: [
      {
        heading: { pre: 'Experiences People', gold: 'Actually Enjoy' },
        subheading:
          'As a UI/UX design agency, we design experiences people actually enjoy using — from first click to final action, every interaction is intentional and delightful.',
        pills: ['Figma', 'Wireframes', 'Prototypes', 'User Research', 'A/B Testing'],
        image: '/ui1.jpeg',
      },
      {
        heading: { pre: 'User-First', gold: 'Design Philosophy' },
        subheading:
          'We put your users at the center of everything we design. Our research-driven approach ensures your product solves real problems beautifully.',
        pills: ['UX Research', 'User Testing', 'Personas', 'Journey Maps', 'Iteration'],
        image: '/ui.jpeg',
      },
      {
        heading: { pre: 'From First Click to', gold: 'Final Conversion' },
        subheading:
          'Our UI/UX designs are engineered not just to look beautiful but to perform — increasing conversions, reducing friction, and growing your business.',
        pills: ['Conversion CRO', 'Mobile UI', 'Web App', 'Dashboard', 'Design Systems'],
        image: '/ui1.jpeg',
      },
    ],
  },
  servicesCards: {
    title: 'Our Comprehensive UI/UX Design Services',
    subtitle:
      'We are a full-service UI/UX design agency that creates digital experiences people love — from initial research through to pixel-perfect final designs.',
    cards: [
      {
        icon: '🔬',
        title: 'UX Research & Discovery',
        description:
          'We conduct in-depth user research, competitor analysis, and usability studies to inform every design decision we make.',
      },
      {
        icon: '📐',
        title: 'Wireframing & Prototyping',
        description:
          'Rapid wireframes and interactive prototypes that bring your ideas to life early, enabling fast iteration and stakeholder buy-in.',
      },
      {
        icon: '🎨',
        title: 'Visual UI Design',
        description:
          'Pixel-perfect, beautiful interfaces that reflect your brand identity and create a consistent, memorable user experience.',
      },
      {
        icon: '📱',
        title: 'Mobile App UI/UX Design',
        description:
          'Native-quality iOS and Android app designs that follow platform conventions while delivering a unique, branded experience.',
      },
      {
        icon: '🖥️',
        title: 'Web & SaaS Dashboard Design',
        description:
          'Complex data-heavy dashboards and SaaS interfaces designed for clarity, efficiency, and delightful ease of use.',
      },
      {
        icon: '⚙️',
        title: 'Design Systems & Style Guides',
        description:
          'Comprehensive design systems and component libraries that ensure consistency across your entire product and team.',
      },
    ],
  },
  features: {
    title: 'UI/UX Design Services for Accelerated Business Growth',
    subtitle:
      'Create digital experiences that enhance user satisfaction, elevate your brand perception, and drive measurable business results.',
    items: [
      'User Research',
      'Competitive Analysis',
      'Information Architecture',
      'Wireframing',
      'Interactive Prototypes',
      'Usability Testing',
      'Visual Design',
      'Design Systems',
      'Micro-animations',
      'Accessibility (WCAG)',
      'Responsive Design',
      'Handoff to Dev',
    ],
  },
  excellence: {
    title: 'Collaborative Excellence',
    subtitle:
      "At RojrzTech, we prioritize collaboration to ensure the best design outcomes for our clients. We maintain constant communication, refining every interface until you're completely satisfied.",
    cards: [
      {
        icon: '🎯',
        title: 'Intuitive User Interfaces',
        description:
          'Our primary objective is to develop user-friendly interfaces that feel natural, reduce cognitive load, and keep users engaged.',
      },
      {
        icon: '🔒',
        title: 'Secure & Reliable Deployment',
        description:
          'Our designs are developer-friendly and include detailed specifications ensuring pixel-perfect implementation every time.',
      },
      {
        icon: '⭐',
        title: 'Versatile Design Solutions',
        description:
          'From mobile apps to complex SaaS dashboards, our designs are adaptable to any screen, platform, or user context.',
      },
      {
        icon: '🔬',
        title: 'Research-Driven Decisions',
        description:
          'Every design choice is backed by user research and data, ensuring we solve real problems rather than just making things pretty.',
      },
      {
        icon: '✏️',
        title: 'Tailored Visual Identity',
        description:
          'We craft designs that authentically reflect your brand while meeting the highest standards of usability and aesthetics.',
      },
      {
        icon: '🚀',
        title: 'High Performance Designs',
        description:
          'Our designs are optimized for performance — lightweight assets, efficient layouts, and smooth animations that never slow things down.',
      },
    ],
  },
  relatedServices: ALL_SERVICES.filter((s) => s.href !== '/services/ui-ux-design'),
};

const UiUxDesign = () => <ServicePageTemplate pageData={pageData} />;
export default UiUxDesign;
